import React from "react";
import { fileIcon } from "utils/data";

export const FileNameSection = ({ fileName }) => {
  return (
    <div className="d-inline-flex align-items-center gap-3">
      <img src={fileIcon} alt={"File Name"} className="img-fluid" />
      <h6 className="m-0 max-line-1 ">{fileName}</h6>
    </div>
  );
};
